/**
 * For version 2, Chat-GPT 4 decided to add winner-handling.
 */

import React, { useState } from 'react';

enum Player {
  None = 'none',
  One = 'one',
  Two = 'two',
}

const initializeBoard = (): Player[][] => {
  return Array(3)
    .fill(null)
    .map(() => Array(3).fill(Player.None));
};

const ChessGPTv2 = () => {
  const [board, setBoard] = useState(initializeBoard);
  const [currentPlayer, setCurrentPlayer] = useState(Player.One);
  const [winner, setWinner] = useState(Player.None);

  const checkForWinner = (board: Player[][]): Player => {
    // Check rows
    for (let i = 0; i < 3; i++) {
      if (
        board[i][0] !== Player.None &&
        board[i][0] === board[i][1] &&
        board[i][0] === board[i][2]
      ) {
        return board[i][0];
      }
    }

    // Check columns
    for (let i = 0; i < 3; i++) {
      if (
        board[0][i] !== Player.None &&
        board[0][i] === board[1][i] &&
        board[0][i] === board[2][i]
      ) {
        return board[0][i];
      }
    }

    // Check diagonals
    if (
      board[0][0] !== Player.None &&
      board[0][0] === board[1][1] &&
      board[0][0] === board[2][2]
    ) {
      return board[0][0];
    }
    if (
      board[0][2] !== Player.None &&
      board[0][2] === board[1][1] &&
      board[0][2] === board[2][0]
    ) {
      return board[0][2];
    }

    return Player.None;
  };

  const handleCellClick = (x: number, y: number) => {
    if (board[x][y] !== Player.None) return;

    const newBoard = board.map((row) => [...row]);
    newBoard[x][y] = currentPlayer;
    setBoard(newBoard);

    const winner = checkForWinner(newBoard);
    if (winner !== Player.None) {
      setWinner(winner);
    } else {
      setCurrentPlayer(currentPlayer === Player.One ? Player.Two : Player.One);
    }
  };

  return (
    <div className="App">
      <div>
        {board.map((row, x) => (
          <div key={x}>
            {row.map((cell, y) => (
              <button key={y} onClick={() => handleCellClick(x, y)}>
                {cell}
              </button>
            ))}
          </div>
        ))}
      </div>
      {winner !== Player.None ? (
        <div>Winner: {winner}</div>
      ) : (
        <div>Current Player: {currentPlayer}</div>
      )}
    </div>
  );
};

export default ChessGPTv2;
